module.exports = __webpack_public_path__ + "static/media/parent registration.6afd19eb.svg";